import React from "react";
import { Link } from "react-router-dom";

function Pricing() {
  return (
    <section className="pbminfotech-ele-ptable-style-2" id="pricing">
      <div className="container">
        <div className="pbmit-heading-subheading text-center animation-style1">
          <h4 className="pbmit-subtitle">
            <span></span>Our Pricing Plans
          </h4>
          <h2 className="pbmit-title">Choose the Best Fitness Plan</h2>
        </div>

        <div className="row">
          <div className="pbmit-pricing-table-featured-col pbmit-ptable-col col-lg-12">
            <div className="pbmit-pricing-table-box">
              <div className="pbmit-ptablebox-featured-w"></div>

              <div className="pbmit-head-wrap">
                <div className="pbminfotech-ptable-price-w">
                  <h3 className="pbminfotech-ptable-heading">
                    3 Days Trial Plan
                  </h3>
                  <div className="pbminfotech-sep"></div>
                  {/* <div className="pbminfotech-ptable-frequency">
                      Best for Consistency
                    </div> */}
                </div>
              </div>

              <div className="pbmit-ptable-inner">
                <div className="pbmit-ptable-lines-w">
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Free AI workout plan
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Limited Classes Each
                    Day(Only one booking)
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-ban"></i> No Custom Diet or Workout
                    plans
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-ban"></i> No 1-to-1 Coaching
                  </div>
                  {/*  */}
                  {/* <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> 1 Month Plan
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> 3 Months Plan
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> 6 Months Plan
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> 12 Months Plan
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Any Plan
                  </div> */}
                </div>

                <div className="pbminfotech-ptable-btn">
                  <div className="pbmit-price-box">
                    <div className="pbmit-price-wrapper">
                      <div className="pbminfotech-ptable-symbol">₹</div>
                      <div className="pbminfotech-ptable-price">399</div>
                    </div>
                  </div>
                  <div className="pbmit-ptable-btn">
                    <a
                      href="https://pages.razorpay.com/pl_SC05z5g6Tyoo52/view"
                      target="_blank"
                    >
                      Select Plan
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pbmit-ptable-col col-lg-12">
            <div className="pbmit-pricing-table-box">
              <div className="pbmit-head-wrap">
                <div className="pbminfotech-ptable-price-w">
                  <h3 className="pbminfotech-ptable-heading">1 Month Plan</h3>
                  <div className="pbminfotech-sep"></div>
                  <div className="pbminfotech-ptable-frequency">
                    Short Term Plan
                  </div>
                </div>
              </div>

              <div className="pbmit-ptable-inner">
                <div className="pbmit-ptable-lines-w">
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> HIIT Classes
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Dance Fitness Classes
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Yoga Sessions
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Basic Workout Guidance
                  </div>
                </div>

                <div className="pbminfotech-ptable-btn">
                  <div className="pbmit-price-box">
                    <div className="pbmit-price-wrapper">
                      <div className="pbminfotech-ptable-symbol">₹</div>
                      <div className="pbminfotech-ptable-price">
                        999 <del>1299</del>
                      </div>
                    </div>
                  </div>
                  <div className="pbmit-ptable-btn">
                    <a
                      href="https://pages.razorpay.com/pl_SC05z5g6Tyoo52/view"
                      target="_blank"
                    >
                      Select Plan
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pbmit-pricing-table-featured-col pbmit-ptable-col col-lg-12">
            <div className="pbmit-pricing-table-box">
              <div className="pbmit-ptablebox-featured-w"></div>

              <div className="pbmit-head-wrap">
                <div className="pbminfotech-ptable-price-w">
                  <h3 className="pbminfotech-ptable-heading">3 Months Plan</h3>
                  <div className="pbminfotech-sep"></div>
                  <div className="pbminfotech-ptable-frequency">
                    Best for Consistency
                  </div>
                </div>
              </div>

              <div className="pbmit-ptable-inner">
                <div className="pbmit-ptable-lines-w">
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> HIIT Class
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Dance Fitness Classes
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Yoga Classes
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Free Nutrition Tracking
                  </div>
                  {/*  */}
                  {/* <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Progress Monitoring
                  </div> */}
                </div>

                <div className="pbminfotech-ptable-btn">
                  <div className="pbmit-price-box">
                    <div className="pbmit-price-wrapper">
                      <div className="pbminfotech-ptable-symbol">₹</div>
                      <div className="pbminfotech-ptable-price">
                        2599 <del>2999</del>
                      </div>
                    </div>
                  </div>
                  <div className="pbmit-ptable-btn">
                    <a
                      href="https://pages.razorpay.com/pl_SC05z5g6Tyoo52/view"
                      target="_blank"
                    >
                      Select Plan
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pbmit-ptable-col col-lg-12">
            <div className="pbmit-pricing-table-box">
              <div className="pbmit-head-wrap">
                <div className="pbminfotech-ptable-price-w">
                  <h3 className="pbminfotech-ptable-heading">6 Months Plan</h3>
                  <div className="pbminfotech-sep"></div>
                  <div className="pbminfotech-ptable-frequency">
                    Most Popular
                  </div>
                </div>
              </div>

              <div className="pbmit-ptable-inner">
                <div className="pbmit-ptable-lines-w">
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> HIIT Class
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Dance Fitness Classes
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Yoga Classes
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Nutrition Tracking
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Progress Monitoring
                  </div>
                  {/*  */}
                  {/* <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Monthly Fitness Assessment
                  </div> */}
                </div>

                <div className="pbminfotech-ptable-btn">
                  <div className="pbmit-price-box">
                    <div className="pbmit-price-wrapper">
                      <div className="pbminfotech-ptable-symbol">₹</div>
                      <div className="pbminfotech-ptable-price">
                        4999 <del>5999</del>
                      </div>
                    </div>
                  </div>
                  <div className="pbmit-ptable-btn">
                    <a
                      href="https://pages.razorpay.com/pl_SC05z5g6Tyoo52/view"
                      target="_blank"
                    >
                      Select Plan
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pbmit-pricing-table-featured-col pbmit-ptable-col col-lg-12">
            <div className="pbmit-pricing-table-box">
              <div className="pbmit-ptablebox-featured-w"></div>

              <div className="pbmit-head-wrap">
                <div className="pbminfotech-ptable-price-w">
                  <h3 className="pbminfotech-ptable-heading">12 Months Plan</h3>
                  <div className="pbminfotech-sep"></div>
                  <div className="pbminfotech-ptable-frequency">Best Value</div>
                </div>
              </div>

              <div className="pbmit-ptable-inner">
                <div className="pbmit-ptable-lines-w">
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> HIIT Classes
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Dance Fitness Classes
                  </div>{" "}
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Yoga Classes
                  </div>{" "}
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Nutrition Tracking
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Progress monitoring
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Free AI workout plan
                  </div>
                  {/*  */}
                  {/* <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Free Group Classes
                  </div>
                  <div className="pbmit-ptable-line">
                    <i className="fa fa-check"></i> Personal Trainer Support
                  </div> */}
                </div>

                <div className="pbminfotech-ptable-btn">
                  <div className="pbmit-price-box">
                    <div className="pbmit-price-wrapper">
                      <div className="pbminfotech-ptable-symbol">₹</div>
                      <div className="pbminfotech-ptable-price">
                        10999 <del>11999</del>
                      </div>
                    </div>
                  </div>
                  <div className="pbmit-ptable-btn">
                    <a
                      href="https://pages.razorpay.com/pl_SC05z5g6Tyoo52/view"
                      target="_blank"
                    >
                      Select Plan
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Pricing;
